import React, {
    ReactElement, useState,
} from "react";
import { Card } from "react-bootstrap";
import { FaUser } from "react-icons/fa";
import { GiGears } from "react-icons/gi";
import { GoVerified } from "react-icons/go";
import { Filters } from "../../../../components/filters/Filters";
import Loading from "../../../../components/loading/Loading";
import useRouting, { Link } from "../../../../contexts/Routing";
import { IntegrationActionType, useGetWorkflowServicesQuery } from "../../../../__generated__/api";
import { NoDataOrError } from "../../../error/Error";
import Styles from "./Services.module.scss";

const INSTALLED_CATEGORY = "installed";
const NOT_INSTALLED_CATEGORY = "not-installed";
const CATEGORIES = [
    {
        id: INSTALLED_CATEGORY,
        name: "Installed",
    },
    {
        id: NOT_INSTALLED_CATEGORY,
        name: "Not Installed",
    },
];

export default function WorkflowServices(): ReactElement {
    const { Paths } = useRouting();
    const { data: services, loading: isLoading, error } = useGetWorkflowServicesQuery();

    const [filterCategory, setFilterCategory] = useState(new Set<string>());
    const [search, setSearch] = useState("");

    if (isLoading) {
        return <Loading />;
    }
    if (error || !services?.workflowServices) {
        return <NoDataOrError error={error} />;
    }
    let serviceList = services.workflowServices;
    if (search) {
        const searchQuery = search.toLowerCase();
        serviceList = serviceList.filter(service => service.name.toLowerCase().includes(searchQuery)
                    || service.shortDescription?.toLowerCase().includes(searchQuery));
    }
    if (filterCategory?.has(INSTALLED_CATEGORY)) {
        serviceList = serviceList.filter(service => service.installedIntegrationIds.isNotEmpty);
    } else if (filterCategory?.has(NOT_INSTALLED_CATEGORY)) {
        serviceList = serviceList.filter(service => !service.installedIntegrationIds.isNotEmpty);
    }

    return (

        <form className="flex-grow-1">

            <div className="border p-3 rounded mb-5 bg-white">
                <Filters
                    onSetSearch={setSearch}
                    search={search}
                    onSelected={data => setFilterCategory(data)}
                    selectedCategories={filterCategory}
                    categories={CATEGORIES}
                    className="mb-3"
                />
                <div className="d-flex align-items-stretch flex-wrap">
                    {serviceList.sortBy("name").map(service => (

                        <div className="col-12 col-md-6 col-xl-3 px-2 pb-3">
                            <Card className="d-flex flex-column h-100">
                                <Link
                                    className="btn btn-none text-start flex-grow-1 d-flex flex-column align-items-center"
                                    to={Paths.ADMINISTRATOR_SETTING_ID}
                                    params={{
                                        setting: "workflow-service",
                                        id: service.id,
                                    }}
                                >
                                    <Card.Img src={service.iconUrl as string} className={`p-4 ${Styles.icon}`} />
                                    <Card.Body>
                                        <Card.Title>{service.name}</Card.Title>
                                        <Card.Text className="text-wrap text-gray-500">
                                            {service.shortDescription}
                                        </Card.Text>

                                    </Card.Body>
                                </Link>
                                <Card.Footer className="bg-white d-flex justify-content-between ">
                                    <div className="text-light">
                                        {service.actionTypes?.includes(IntegrationActionType.Execute)
                                        && (
                                            <GiGears
                                                className="me-2"
                                                title="This integration is able to execute certain
                                                        actions in the 3rd party service."
                                            />
                                        )}
                                        {service.actionTypes?.includes(IntegrationActionType.UserDataProvider)
                                        && (
                                            <FaUser
                                                title="This integration is able to annotate user
                                                        information when displaying a user in Agent Web."
                                            />
                                        )}
                                    </div>
                                    {service.installedIntegrationIds?.isNotEmpty ? (
                                        <span className="text-success">
                                            <GoVerified />
                                            {" "}
                                            Installed
                                        </span>
                                    ) : (
                                        <Link
                                            className="btn btn-link"
                                            to={Paths.ADMINISTRATOR_SETTING_ID}
                                            params={{
                                                setting: "workflow-service",
                                                id: service.id,
                                            }}
                                        >
                                            Open to Install
                                        </Link>
                                    )}

                                </Card.Footer>

                            </Card>
                        </div>

                    ))}
                </div>

            </div>

        </form>
    );
}
